'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$68() {
  this.aHZ = null;
  this.aI0 = false;
}
export { $c_Lpresto_CredentialsView$$anon$68 as $c_Lpresto_CredentialsView$$anon$68 };
$p = $c_Lpresto_CredentialsView$$anon$68.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$68;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$68() {
}
export { $h_Lpresto_CredentialsView$$anon$68 as $h_Lpresto_CredentialsView$$anon$68 };
$h_Lpresto_CredentialsView$$anon$68.prototype = $p;
$p.P = (function() {
  if ((!this.aI0)) {
    this.aHZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.aI0 = true;
  }
  return this.aHZ;
});
var $d_Lpresto_CredentialsView$$anon$68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$68, "presto.CredentialsView$$anon$68", ({
  Gx: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_CredentialsView$$anon$68 as $d_Lpresto_CredentialsView$$anon$68 };
//# sourceMappingURL=presto.-Credentials-View$$anon$68.js.map
